import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres32e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres32e/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtereq_st: (typeof searchParams.dtereqst !== 'undefined' ? searchParams.dtereqst : ''),
        p_dtereq_en: (typeof searchParams.dtereqen !== 'undefined' ? searchParams.dtereqen : '')
      }
    }
    return instance().get(endpoint + '/hres32e/index', { params: sendParams })
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres32e/dropdowns')
  },
  getDropdowns2 () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres32e/dropdowns2')
  },
  getDetailIndex () {
    if (isMock) return generator(mocker.detailIndex())
    return instance().get(endpoint + '/hres32e/detailIndex')
  },
  getDetailTopic () {
    if (isMock) return generator(mocker.detailTopicx())
    return instance().get(endpoint + '/hres32e/detailTopic')
  },
  getDetailTab1Crate (paramSearchDetail) {
    if (isMock) return generator(mocker.detailTab1())
    let searchParams = {
      p_dtereq: paramSearchDetail.dtereq,
      p_codempid_query: paramSearchDetail.codempid_query
    }
    const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_codempid_query
    return instance().get(endpoint + '/hres32e/detail1Create/' + params)
  },
  getDetailTab2_6Crate (paramSearchDetail) {
    if (isMock) return generator(mocker.detailTab2_6())
    let searchParams = {
      p_dtereq: paramSearchDetail.dtereq,
      p_codempid_query: paramSearchDetail.codempid_query
    }
    const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_codempid_query
    return instance().get(endpoint + '/hres32e/detail2to6Create/' + params)
  },
  getDetailTab1 (detailParams) {
    if (isMock) return generator(mocker.detailTab1())
    let searchParams = {
      p_dtereq: detailParams.dtereq,
      p_numseq: detailParams.numseq,
      p_typchg: detailParams.typchg
    }
    const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq + '/' + searchParams.p_typchg
    return instance().get(endpoint + '/hres32e/detail1/' + params)
  },
  getDetailTab2_6 (detailParams) {
    if (isMock) return generator(mocker.detailTab2_6())
    let searchParams = {
      p_dtereq: detailParams.dtereq,
      p_numseq: detailParams.numseq,
      p_typchg: detailParams.typchg
    }
    const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq + '/' + searchParams.p_typchg
    return instance().get(endpoint + '/hres32e/detail2to6/' + params)
  },
  postDetail1Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail1Save', saveParams)
  },
  postDetail2Tab1Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab1Save', saveParams)
  },
  postDetail2Tab2Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab2Save', saveParams)
  },
  postDetail2Tab3Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab3Save', saveParams)
  },
  postDetail2Tab4Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab4Save', saveParams)
  },
  postDetail2Tab5Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab5Save', saveParams)
  },
  postDetail2Tab6Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab6Save', saveParams)
  },
  postDetail2Tab7Save (dataRowsHasFlg, indexSelected) {
    var params = []
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      var dataRow = dataRowsHasFlg[i]
      var dterecv = (typeof dataRow.dterecv !== 'undefined') ? dataRow.dterecv.replace(/\//g, '') : ''
      var dtedocen = (typeof dataRow.dtedocen !== 'undefined') ? dataRow.dtedocen.replace(/\//g, '') : ''
      params.push({
        'p_codempid': dataRow.codempid,
        'p_dtereq': dataRow.dtereq,
        'p_numseq': dataRow.numseq,
        'numseq': dataRow.numseq,
        'typdoc': dataRow.typdoc,
        'namdoc': dataRow.namdoc,
        'dterecv': dterecv,
        'dtedocen': dtedocen,
        'numdoc': dataRow.numdoc,
        'filedoc': dataRow.filedoc,
        'desnote': dataRow.desnote,
        'status': dataRow.status,
        'desc_status': dataRow.desc_status,
        'codempid_query': dataRow.codempid
      })
    }
    var saveParams = {
      'p_codempid': indexSelected.codempid,
      'p_dtereq': indexSelected.dtereq,
      'p_numseq': indexSelected.numseq,
      'p_param': JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab7Save', saveParams)
  },
  postDetail3Save (dataRowsHasFlg, indexSelected) {
    var params = []
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      var dataRow = dataRowsHasFlg[i]
      params.push({
        'p_codempid': dataRow.codempid,
        'p_dtereq': dataRow.dtereq,
        'p_numseq': dataRow.numseq,
        'numseq': dataRow.numseq,
        'codedlv': dataRow.codedlv,
        'coddglv': dataRow.coddglv,
        'codmajsb': dataRow.codmajsb,
        'codminsb': dataRow.codminsb,
        'codinst': dataRow.codinst,
        'codcount': dataRow.codcount,
        'numgpa': dataRow.numgpa,
        'stayear': dataRow.stayear,
        'dtegyear': dataRow.dtegyear,
        'flgeduc': dataRow.flgeduc
      })
    }
    var saveParams = {
      'p_codempid': indexSelected.codempid,
      'p_dtereq': indexSelected.dtereq,
      'p_numseq': indexSelected.numseq,
      'p_param': JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail3Save', saveParams)
  },
  postDetail4Save (dataRowsHasFlg, indexSelected) {
    var params = []
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      var dataRow = dataRowsHasFlg[i]
      var dtechbd = (typeof dataRow.dtechbd !== 'undefined') ? dataRow.dtechbd.replace(/\//g, '') : ''
      params.push({
        'p_codempid': dataRow.codempid,
        'p_dtereq': dataRow.dtereq,
        'p_numseq': dataRow.numseq,
        'numseq': dataRow.numseq,
        'namchild': dataRow.namchild,
        'numoffid': dataRow.numoffid,
        'dtechbd': dtechbd,
        'namsex': dataRow.namsex,
        'codeduc2': dataRow.codedlv
      })
    }
    var saveParams = {
      'p_codempid': indexSelected.codempid,
      'p_dtereq': indexSelected.dtereq,
      'p_numseq': indexSelected.numseq,
      'p_param': JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail4Save', saveParams)
  },
  postDetail5Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail5Save', saveParams)
  },
  postDetail6Save (dataRowsHasFlg, indexSelected) {
    var params = []
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      var dataRow = dataRowsHasFlg[i]
      var dtetrain = (typeof dataRow.dtetrain !== 'undefined') ? dataRow.dtetrain.replace(/\//g, '') : ''
      var dtetren = (typeof dataRow.dtetren !== 'undefined') ? dataRow.dtetren.replace(/\//g, '') : ''
      params.push({
        'p_codempid': dataRow.codempid,
        'p_dtereq': dataRow.dtereq,
        'p_numseq': dataRow.numseq,
        'numseq': dataRow.numseq,
        'dtetrain': dtetrain,
        'destrain': dataRow.destrain,
        'dtetren': dtetren,
        'desplace': dataRow.desplace,
        'desinstu': dataRow.desinstu
      })
    }
    var saveParams = {
      'p_codempid': indexSelected.codempid,
      'p_dtereq': indexSelected.dtereq,
      'p_numseq': indexSelected.numseq,
      'p_param': JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail6Save', saveParams)
  },
  postCancel (cancelParams) {
    if (isMock) return generator(mocker.cancel())
    return instance().post(endpoint + '/hres32e/cancel', cancelParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres32e/index.js